import { AppHostDevicePermissionService } from './AppHostDevicePermissionService';
import { DialogService } from './AppHostDialogService';
import { AppHostHubUiService } from './AppHostHubUiService';
import { AppInstallDialogService } from './AppHostInstallDialogService';
import { AppHostLinkService } from './AppHostLinkService';
import { AppHostLocationService } from './AppHostLocationService';
import { AppHostPageService } from './AppHostPageService';
export function createHubServices(args) {
    var addEventListenerCallback = args.addEventListenerCallback, appbarConnectorService = args.appbarConnectorService, appId = args.appId, appLinkDomains = args.appLinkDomains, appLinkRootPath = args.appLinkRootPath, authenticationService = args.authenticationService, capabilitiesFeatureGates = args.capabilitiesFeatureGates, dialogHandlers = args.dialogHandlers, locStrings = args.locStrings, navigateForwardCallback = args.navigateForwardCallback, navigateToAppCallback = args.navigateToAppCallback, officeComponentContext = args.officeComponentContext, retryCallback = args.retryCallback, setFrameInfoCallback = args.setFrameInfoCallback, setShareLinkCallback = args.setShareLinkCallback, showConsentDialogCallback = args.showConsentDialogCallback, telemetryService = args.telemetryService, userId = args.userId;
    var hubUiService = new AppHostHubUiService(officeComponentContext.correlationId, retryCallback, locStrings, telemetryService, appId);
    var pageService = new AppHostPageService(navigateForwardCallback, navigateToAppCallback, setShareLinkCallback, setFrameInfoCallback, addEventListenerCallback, {
        appLinkDomains: appLinkDomains,
        appLinkRootPath: appLinkRootPath,
        appbarConnectorService: appbarConnectorService,
    });
    var linkService = new AppHostLinkService(officeComponentContext.officeHomeApiRoot);
    var appInstallDialogService = new AppInstallDialogService();
    // TODO: all conditions when permission service should be disabled
    var permissionServiceDisabled = appId === 'apps' || !userId;
    var devicePermissionService = !permissionServiceDisabled
        ? new AppHostDevicePermissionService(appId, userId, showConsentDialogCallback)
        : undefined;
    var locationService = !permissionServiceDisabled
        ? new AppHostLocationService()
        : undefined;
    var dialogService = capabilitiesFeatureGates.dialogServiceEnabled
        ? new DialogService(dialogHandlers)
        : undefined;
    var logger = {
        log: function (level, tag, message, exception) {
            return;
        },
    };
    var hubServices = {
        appInstallDialogService: appInstallDialogService,
        authenticationService: authenticationService,
        devicePermissionService: devicePermissionService,
        hubUiService: hubUiService,
        linkService: linkService,
        locationService: locationService,
        pageService: pageService,
        telemetryService: telemetryService,
        logger: logger,
    };
    hubServices.dialogService = dialogService;
    return hubServices;
}
//# sourceMappingURL=createHubServices.js.map